import moment from 'moment'
moment.locale('pt-br');
export const listingFormated = state => {
  return state.listing.map(item => {
    item.revoked_fields = item.revoked_fields == null ? [] : JSON.parse(item.revoked_fields);
    item.consented_fields = item.consented_fields == null ? [] : JSON.parse(item.consented_fields);
    item.changed_fields  = item.changed_fields  == null ? [] : JSON.parse(item.changed_fields);
    item.text = '';
    if(item.revoked_fields.length){
      var revokeText = ( item.customer_name != null ? "Revogou para "+ item.customer_name +" os campos " : "Revogou os campos " );
      item.text = revokeText + getName(item.revoked_fields) + '; ';
    }

    if(item.consented_fields.length){
      var consentText = ( item.customer_name != null ? "Consentiu para "+ item.customer_name +" os campos " : "Consentiu os campos " );
      item.text += consentText + getName(item.consented_fields) +'; ';
    }

    if(item.changed_fields.length){
      var changeText = ( item.customer_name != null ? "Alterou para "+ item.customer_name +" os campos " : "Alterou os campos " );
      item.text += changeText + getName(item.changed_fields) +'; ';
    }

    item.longTxt = item.text;
    if (item.text.length > 21) {
      item.text = item.text.slice(0, 20) + '...';
    }

    item.cstr_short = item.customer_name;
    if ( item.customer_name != null && item.customer_name.length > 12) {
      item.cstr_short = item.customer_name.slice(0, 10) + '...';
    }
    
    function getName(arr){
      var dic = {
        'gender': 'Gênero',
        'name': 'Nome',
        'email': 'Email',
        'locale': 'Localidade',
        'birthday': 'Aniversário',
        'docnumber': 'Documento',
        'phone': 'Telefone',
        'photo': 'Foto'
      }
      var array = [];
      for (var i = 0; i < arr.length; i++) {
        array.push(dic[arr[i]]);
      }
      return array.join(', ');
    }

    if (item.done == 0) {
      item.status = 'Em Andamento'
    }else if(item.done == 1){
      item.status = "Finalizado"
    }

    if (item.created_at !== undefined) {
      item.created_at = moment(item.created_at).format('L HH:mm');
    }
    return item;
  });
}
